import { render, staticRenderFns } from "./ChiefDeptNavigationDrawerStudNav.vue?vue&type=template&id=6f9c387c"
import script from "./ChiefDeptNavigationDrawerStudNav.vue?vue&type=script&lang=js"
export * from "./ChiefDeptNavigationDrawerStudNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports